import SvgFaq from "components/faq/svgFaqSingle";
import Button from "components/general/buttonv2";
import { DISCORD_LINK } from "data/variables";
import styled from "styled-components";

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-x: hidden;
`;
const StyledWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  margin-top: 2rem;
  justify-content: center;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;
const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }
`;
const StyledPreviewWrapper = styled.div`
  top: 0;
  margin: 5rem 4rem 0 4rem;
  flex: 2;
  position: relative;
  svg {
    width: 400px;
    height: auto;
    max-width: 100%;
  }
  @media screen and (max-width: 768px) {
    margin: 1rem 2rem;
  }
`;
const StyledText = styled.div`
  flex: 3;
  padding: 0 2rem 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  > h2 {
    line-height: 4rem;
    font-size: 3.375rem;
    font-weight: 700;
    margin: 2rem 0 0 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 768px) {
      line-height: 4.2rem;
      font-size: 3rem;
    }
  }
  > p {
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
  }
  @media screen and (max-width: 1280px) {
    padding: 0 2rem 2rem 2rem;
  }
`;
const ContentBlockTwo = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <StyledContainer>
          <StyledText>
            <h2>Got a specific question?</h2>
            <p>Join our Discord server and we will directly answer your questions in real time!</p>
            <Button buttonPrimary={true} href={DISCORD_LINK}>
              Join Redact Discord
            </Button>
          </StyledText>
          <StyledPreviewWrapper>
            <SvgFaq />
          </StyledPreviewWrapper>
        </StyledContainer>
      </StyledWrapper>
    </StyledSection>
  );
};

export default ContentBlockTwo;
